export default __webpack_public_path__ + "static/media/code.98a75598.svg";